export default __webpack_public_path__ + "static/media/test_drive.2c20632c.svg";